import { HubConnectionBuilder } from '@microsoft/signalr';
import { setRegeneratingDownloads } from 'store/configurationSidebar/actions';
import store from 'store/store';

export default async (): Promise<void> => {
  const connection = new HubConnectionBuilder().withUrl('/ws').build();

  connection.on('downloads-generation-finished', () => {
    store.dispatch(setRegeneratingDownloads(false));
  });

  await connection.start();
};
